/**
 * Resolves the global row object for a page-relative click.
 *
 * @param tableData - Full dataset currently being rendered
 * @param rowIndex - Index within the current page
 * @param startIndex - Global start index of the page
 * @returns The row data for the clicked row
 */
export const getRowDataToPass = (
  tableData: any[],
  rowIndex: number,
  startIndex: number,
) => {
  const rowDataToPassIndex = rowIndex + startIndex;
  return tableData[rowDataToPassIndex];
};

/**
 * Routes a row/cell click to the appropriate parent callback using CSS class
 * markers (medonc parity). For STRING-only tables this typically falls through
 * to `onRowClick`.
 *
 * @param tableData - Full table data array
 * @param rowIndex - Page-relative row index
 * @param className - Clicked cell className
 * @param startIndex - Global page start index
 * @param props - Optional click handlers
 */
export const handleRowClickAction = (
  tableData: any,
  rowIndex: number,
  className: string,
  startIndex: number,
  props: {
    onRowClick?: (rowData: any) => void;
    toggleCheckboxSelection?: (id: string) => void;
  },
): void => {
  const rowDataToPass = getRowDataToPass(tableData, rowIndex, startIndex);

  if (className.includes("checkbox__select")) {
    props.toggleCheckboxSelection?.(rowDataToPass?.id);
    return;
  }

  props.onRowClick?.(rowDataToPass);
};
